import React from 'react';
import Heading from '../Heading/Heading';
import './Hero.scss';

export interface HeroPrimaryContentProps {
  children?: React.ReactNode | React.ReactNode[];
  title?: React.ReactNode | React.ReactNode[];
}

const HeroPrimaryContent: React.FC<HeroPrimaryContentProps> = ({
  children,
  title
}: HeroPrimaryContentProps) => {
  return (
    <div className="mss-hero__title">
      {title && (
        <Heading as="h1" level={1} alternative>
          {title}
        </Heading>
      )}
      {children}
    </div>
  );
};

export default HeroPrimaryContent;
